import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { GET_URL } from '@utils/api/endpoints.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { TagAssignmentListResponse } from '@utils/types/organization/tag.ts';
import { QueryKeys } from '@utils/api/query-keys.ts';

type GetTagAssignmentsVariables = {
  session_id: string;
  document_id: string;
  enabled?: boolean;
};

export const useGetTagAssignments = ({
  session_id,
  document_id,
  enabled = true
}: GetTagAssignmentsVariables) => {
  const fetchTagAssignments = async () => {
    const url = GET_URL(session_id, document_id).tagAssignments;
    const response = await Axios.get<TagAssignmentListResponse>(url);
    return response.data;
  };

  return useQuery<TagAssignmentListResponse, AxiosError<BaseError>>(
    QueryKeys.tagAssignments(session_id, document_id),
    fetchTagAssignments,
    {
      enabled: enabled && !!session_id && !!document_id
    }
  );
};
